export default class SupplyOfferStatus {
  constructor(public id: string, public name: string) {}

  static fromServer(data: any): SupplyOfferStatus {
    return new SupplyOfferStatus(data.id, data.name);
  }

  toString() {
    return this.name;
  }
}
